import type { User } from "firebase/auth";
import { mountRankPage } from "@/mount-rank-page";

let activeClose: (() => void) | null = null;

export function isRankModalOpen(): boolean {
  return Boolean(document.querySelector(".rank-modal"));
}

/** World leaderboard as overlay on home. */
export async function openRankModal(user: User): Promise<() => void> {
  if (activeClose) return activeClose;

  const overlay = document.createElement("div");
  overlay.className = "tower-modal rank-modal";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-label", "อันดับโลก");

  const backdrop = document.createElement("button");
  backdrop.type = "button";
  backdrop.className = "tower-modal-backdrop";
  backdrop.setAttribute("aria-label", "ปิด");

  const shell = document.createElement("div");
  shell.className = "tower-modal-shell rank-modal-shell page-rank-lobby";
  overlay.append(backdrop, shell);
  document.body.appendChild(overlay);
  document.body.classList.add("has-tower-modal");

  let pageTeardown: (() => void) | null = null;

  const close = () => {
    pageTeardown?.();
    pageTeardown = null;
    overlay.remove();
    document.body.classList.remove("has-tower-modal");
    activeClose = null;
    window.removeEventListener("keydown", onKeyDown);
  };

  activeClose = close;
  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") close();
  };
  window.addEventListener("keydown", onKeyDown);
  backdrop.addEventListener("click", () => close());

  pageTeardown = await mountRankPage(shell, user, {
    asModal: true,
    onRequestClose: close,
  });

  return close;
}
